module.exports = __webpack_public_path__ + "img/applySharer_bind_fail.a242cb82.png";